/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface ContasPagas {
  dataemissao: Date;
  datalan: Date;
  parceiro: string;
  historico: string;
  planoconta: string;
  fazenda: string;
  banco: string;
  numerodoc: string;
  valor: number;
}

interface IParceirosPagas {
  idparceiro: string;
  nome: string;
  cpf: string;
  valor: number;
}

interface EntryPagas {
  contas: IParceirosPagas; 
  contaspagas: ContasPagas[];
}

async function RelatorioContasPagasAgrupados(data: EntryPagas[], periodo: string) {
  const Tparcela = data.reduce((acc, item) => acc + item.contas.valor, 0);

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }


  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 22, 10, 40],
    pageOrientation: 'landscape',
    header: {
      columns: [
        { text: 'Sif - Sistema Integrado de Fazendas', alignment: 'right', color: 'gray', fontSize: 6, margin: [0, 10, 30, 0], }
      ]
    },
    footer: function (currentPage: number, pageCount: number) {
      return {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: 'right',
        fontSize: 6,
        color: 'gray',
        margin: [0, 0, 30, 0],
      };
    },
    content: [
      {
        table: {
          body: [
            [
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [720],
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO, alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false] },
                    ],
                    [
                      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
                    ],
                  ]
                }
              },

            ],
            [
              { text: 'Relatório de Contas Pagas', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
              {}
            ]

          ]
        }
      },
      { text: 'Período de: ' + periodo, alignment: 'left', fillColor: '#dddddd', fontSize: 8 },
      data.map(e => {
        const { contas, contaspagas } = e;
        const TValor = contaspagas.reduce((acc, item) => acc + item.valor, 0);
        const rows = contaspagas.map((pagar) => {
          return [
            { text: moment(pagar.dataemissao).format('DD/MM/YYYY'), alignment: 'center', fontSize: 8 },
            { text: moment(pagar.datalan).format('DD/MM/YYYY'), alignment: 'center', fontSize: 8 },
            { text: pagar.numerodoc, alignment: 'left', fontSize: 7 },
            { text: pagar.parceiro, alignment: 'left', fontSize: 7 },
            { text: pagar.fazenda, alignment: 'left', fontSize: 7 },
            { text: pagar.historico, alignment: 'left', fontSize: 7 },
            { text: pagar.planoconta, alignment: 'left', fontSize: 7 },
            { text: pagar.banco, alignment: 'left', fontSize: 7 },
            { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(pagar.valor), alignment: 'right', fontSize: 8 },
          ];
        });

        return [
          [
            [
              {
                margin: [0, 5, 0, 0],
                table: {
                  body: [
                    [
                      {
                        text: 'Parceiros: ' + e.contas.nome + '   ' + (e.contas.cpf.length == 11 ? (
                          'CPF: ' + e.contas.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
                        ) : (
                          'CNPJ: ' + e.contas.cpf.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                        )), bold: true, fontSize: 9, alignment: 'left', border: [false, false, false, false]
                      },
                    ],
                  ]
                },
              },
              {
                table: {
                  widths: [45, 48, 50, 150, 70, 150, 120, 40, 45],
                  body: [
                    [
                      { text: 'Emissão', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Pagamento', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Documento', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Parceiro', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Fazenda', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Histórico', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Plano Conta', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Conta', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
                      { text: 'Valor', alignment: 'right', fillColor: '#dddddd', fontSize: 8 },
                    ],
                    ...rows,
                  ]
                },
              },
              {
                table: {
                  widths: [45, 48, 50, 150, 70, 150, 120, 40, 45],
                  body: [
                    [
                      { text: '', border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                      { text: '', border: [false, false, false, false] },
                      { text: 'Totais', fontSize: 8, alignment: 'right', border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TValor), border: [true, false, true, true], alignment: 'right', fontSize: 7 },
                    ],
                    [
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                      { text: '', border: [false, false, false, true] },
                    ]
                  ]
                },
              }
            ]
          ]

        ];
      }
      ),
      {
        table: {
          widths: [45, 48, 50, 150, 70, 230, 45, 100],
          body: [
            [
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: 'Total Pago', fontSize: 9, alignment: 'right' },
            ],
            [
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Tparcela), fontSize: 10, alignment: 'right' },
            ],
          ]
        },
      }
    ]
  };
  pdfMake.createPdf(documentDefinition).open();
}
export default RelatorioContasPagasAgrupados;

